import React from 'react'

const RedeemPage = () => {
  return (
     <section>
      <p>
        Redemption & Vault Queue Behaviour 1. Overview Redemption is how USCY
        maintains its 1:1 peg. Eligible customers (currently institutional users
        who have passed full KYC and onboarding) return USCY and receive USD at
        par: 1 USCY = 1 USD, subject to programme terms and eligibility. On the
        surface, this behaves like any other fully-backed, 1:1 redeemable
        stablecoin. The difference lies in how redemptions are funded and who is
        economically impacted when a redemption occurs. Redemptions are funded
        by closing collateral vaults at the front of the queue. When a vault is
        closed, the vault owner&apos;s yield window stops: that vault no longer
        accrues yield (rewards). The redeemer is simply exercising their right
        to redeem USCY at par; the vault owner is the one whose yield
        entitlement is affected. This queue-based model makes vault duration
        explicit and gives vault owners a clear way to manage how long their
        deposits continue earning via YPPs. 2. How redemptions work at a high
        level An eligible customer submits a redemption request through the
        platform or an integrated partner. The platform validates the request
        (eligibility, KYC/AML, limits, etc.). The system determines which vaults
        at the front of the queue will be used to fund this redemption. The
        necessary vaults are closed: Cash is released from the USCY Reserves
        Trust, The corresponding USCY tokens are redeemed and removed from
        circulation, The vault owner&apos;s yield streams stop for those closed
        vaults. The redeemer receives USD at par (1 USCY → 1 USD), and the peg
        remains intact. Critically: The redeemer is whoever currently holds USCY
        and exercises redemption. The vault owner is the party whose deposit
        originally created that vault. When a vault is closed at the front of
        the queue, it is the vault owner&apos;s yield window that ends,
        regardless of who the redeemer is. USCY behaves like a standard
        fully-backed stablecoin to the redeemer, while the vault and queue logic
        governs how long vault owners retain yield. 3. The redemption queue:
        front, middle, rear Every open vault sits in a redemption queue. Front
        of the queue Vaults here are next in line to be used to honour
        redemptions. They face the highest liquidation risk and have a short
        remaining yield horizon. When a vault at the front is closed, the vault
        owner&apos;s yield for that deposit stops. Middle of the queue Vaults
        here are in a neutral zone. They are not immediately at risk but are
        gradually moving toward the front over time. Their yield horizon is
        moderate. Rear of the queue Vaults here are best protected. They face
        the lowest liquidation risk and have the longest remaining yield
        horizon. This is generally where vault owners want their high-value
        vaults to sit. Intuitively: Front = bad (short duration, high
        liquidation risk) Middle = OK Rear = good (long duration, low
        liquidation risk) Vault owners are effectively playing to stay away from
        the front. The queue makes that trade-off explicit and measurable. 4.
        What customers see in the UI The platform exposes queue position clearly
        in the collateral positions dashboard. For each open vault, a customer
        can see: Its queue band: Front / Middle / Rear Its exact ranking in the
        queue (e.g. position 12 of 3,482) The rewards (yield) accrued so far for
        that vault Closed vaults are not shown in the collateral positions
        dashboard; once a vault is closed, its lifecycle is complete and its
        yield window has ended. When a customer initiates a YPP spend for a
        specific vault, the interface can show an estimate of the vault&apos;s
        new position in the queue before the spend is confirmed. That estimation
        is part of the YPP spend flow rather than a permanent field on the
        dashboard itself. This gives customers enough information to treat vault
        duration and queue position as parameters they can understand and
        manage, without exposing them to unnecessary complexity. 5. API support
        for active vault management For customers who want to integrate vault
        management into their own systems (e.g. treasury, trading, or risk
        engines), the platform exposes a focused set of API endpoints. For
        active vault management, the core ones are: Get vault positions Returns
        all open vaults for a customer, including: queue band (front / middle /
        rear), exact ranking, notional size, and rewards (yield) accrued so far.
        Estimate YPP spend impact Given a vault ID and a proposed YPP spend,
        returns a projected new ranking and band for that vault. This allows
        customers to simulate the effect of different YPP spend levels before
        actually committing to a spend. These two endpoints are sufficient for
        most active vault management strategies: monitoring drift toward the
        front, and deciding when (and how much) to spend in order to protect
        specific vaults. Standard mint and redeem endpoints exist as part of the
        broader USCY integration, but they are not specific to vault management
        and are documented separately in the API reference. 6. Yield continuity
        during high-velocity workflows In conventional stablecoin models, yield
        (if any) is tied to current token balances. When tokens are: posted into
        off-exchange settlement workflows, used as collateral, or rotated
        through trading and treasury cycles, the reward base falls in lockstep
        with operational flows. The original minter&apos;s economics are
        constantly reset. In USCY, redemptions and queue position decouple that:
        Each mint creates or updates a collateral vault that accrues yield based
        on the original deposit, not the current token balance. USCY tokens can
        move freely through trading, OES, collateral and payment workflows
        without breaking the economic link between the vault owner and their
        original deposit. Yield continues until the vault reaches the front of
        the queue and is closed to fund redemptions. Redemptions close vaults
        and end yield; ordinary trading and balance movements do not. This is
        what allows USCY to behave as a simple 1:1 stablecoin at the token layer
        while preserving economic continuity for vault owners behind the scenes.
        7. Where YPPs enter: controlling when a vault is redeemed By default,
        vaults progress through the queue according to system rules. Vault
        owners who are indifferent to timing can simply accept this default
        lifecycle. Yield Protection Points (YPPs) provide a way for vault owners
        to actively influence when their vaults are likely to be closed: By
        spending YPPs, a vault owner can move a chosen vault further back in the
        redemption queue. The more YPPs spent (relative to others and within
        programme rules), the more favourable the vault&apos;s new position.
        This effectively extends the vault&apos;s remaining yield horizon and
        reduces the chance that it will be used in upcoming redemptions. From
        the perspective of the redemption mechanism: YPPs do not change the 1:1
        redemption terms for USCY holders. YPPs do not introduce yield into the
        token or alter its regulatory profile. They simply re-order which vaults
        are used to fund redemptions, pricing optionality over vault duration.
        For a deeper explanation of YPPs, see /kb/ypp-overview. 8. Summary
        Eligible customers return USCY and receive USD at par (1 USCY = 1 USD),
        subject to programme terms and onboarding. Redemptions are funded by
        closing vaults at the front of the queue; when a vault is closed, the
        vault owner&apos;s yield window stops. Front of the queue = bad, rear =
        good: being further back means more time before potential closure and a
        longer yield horizon. The platform exposes queue position clearly
        through a collateral positions dashboard and via APIs for active vault
        management. YPPs allow vault owners to move specific vaults further back
        in the queue, buying more time without changing the core 1:1 behaviour
        of the stablecoin. This model keeps USCY&apos;s redemption simple and
        predictable at the token level while giving vault owners a transparent,
        controllable framework for managing the economics of their original
        deposits.
      </p>
    </section>
  )
}

export default RedeemPage